import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Flag } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function ReportDialog({ postId }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    if (reason.trim().length < 3) return toast.error("مختصر وجہ لکھیں");
    setSubmitting(true);
    try {
      await api.post("/reports", { post_id: postId, reason });
      toast.success("رپورٹ موصول ہو گئی، نگرانی ٹیم دیکھے گی");
      setOpen(false);
      setReason("");
    } catch {
      toast.error("رپورٹ درج نہیں ہو سکی");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="ghost" title="رپورٹ" data-testid={`report-${postId}`}>
          <Flag size={14} />
        </Button>
      </DialogTrigger>
      <DialogContent dir="rtl">
        <DialogHeader>
          <DialogTitle className="urdu-naskh text-xl">پیغام کی رپورٹ کریں</DialogTitle>
        </DialogHeader>
        <p className="urdu-naskh text-sm text-muted-foreground">وجہ بتائیں تاکہ نگرانی ٹیم درست فیصلہ کر سکے۔</p>
        <Textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="یہ پیغام قابلِ اعتراض ہے کیونکہ…"
          rows={4}
          className="urdu-naskh"
          data-testid="report-reason"
        />
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)}>منسوخ</Button>
          <Button onClick={submit} disabled={submitting} className="bg-destructive hover:bg-destructive/90" data-testid="report-submit">
            {submitting ? "بھیج رہا ہے…" : "رپورٹ بھیجیں"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
